<template>
  <div :class="wrapperClass">
    <label class="group flex w-fit gap-2">
      <span
        class="rounded-xs relative inline-block shrink-0 border transition-colors"
        :class="[
          {
            'border-primary': !modelValue,
            'group-hover:!border-stroke-primary': !modelValue && !isDisabled,
            'border-primary bg-primary': modelValue,
            'border-disabled bg-disabled': isDisabled,
            '!border-error': !isDisabled && isError,
            'cursor-pointer': !isDisabled
          },
          inputClass
        ]"
      >
        <Icon
          name="custom:check"
          size="24"
          class="absolute left-0 top-0 transform-gpu"
          :class="[
            {
              'text-white': modelValue,
              'text-disabled': isDisabled
            },
            ,
            modelValue
              ? 'duration-400 transition-all delay-100 ease-out [clip-path:polygon(0%_0%,100%_0%,100%_100%,0%_100%)]'
              : '[clip-path:polygon(0%_0%,0%_0%,0%_100%,0%_100%)]'
          ]"
        />
      </span>
      <span
        class="transition-colors"
        :class="[
          {
            'cursor-pointer': !isDisabled,
            'text-error': isError
          },
          labelClass
        ]"
      >
        <input
          :id="id"
          v-bind="$attrs"
          type="checkbox"
          class="sr-only"
          :checked="modelValue"
          :disabled="isDisabled"
          @change="updateValue"
          @focus="isFocused = true"
          @blur="isFocused = false"
        />
        <span class="text-text-secondary"
          >{{ label }}<span v-if="isRequired" class="pl-0.5">*</span></span
        >
        <slot />
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '#components'

type FormCheckboxProps = {
  wrapperClass?: string
  inputClass?: string
  modelValue?: boolean
  styleVariant?: 'blue' | 'yellow'
  label: string
  labelClass?: string
  isDisabled?: boolean
  isError?: boolean
  isRequired?: boolean
}

defineOptions({
  inheritAttrs: false
})

withDefaults(defineProps<FormCheckboxProps>(), {
  wrapperClass: 'form-field-checkbox',
  inputClass: `form-checkbox`,
  labelClass: 'form-label-ctrl',
  modelValue: false,
  inputLabel: false,
  styleVariant: 'blue'
})

const emit = defineEmits(['update:modelValue'])

const updateValue = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement).checked)
}

const id = useId()
const isFocused = ref(false)
</script>
